export default {
  language: "Language",
  addLanguage: "AddLanguage",
  editLanguage: "EditLanguage",
};
